
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useLanguage } from '@/contexts/LanguageContext';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <Select value={language} onValueChange={setLanguage}>
      <SelectTrigger title={t('language.change')} aria-label={t('language.change')} className="w-14 h-6 text-xs bg-white/10 d2cbot-bot_border d2cbot-bot_border-white/20 text-white hover:bg-white/20 focus:ring-0 focus:ring-offset-0 px-2 [&>span]:ml-0 [&>svg]:ml-1 [&>svg]:w-3 [&>svg]:h-3">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="z-[999999] bg-white d2cbot-bot_border d2cbot-bot_border-gray-200 shadow-lg">
        <SelectItem value="fr" className="text-sm cursor-pointer hover:bg-gray-100">
          {t('language.french')}
        </SelectItem>
        <SelectItem value="en" className="text-sm cursor-pointer hover:bg-gray-100">
          {t('language.english')}
        </SelectItem>
      </SelectContent>
    </Select>
  );
};

export default LanguageToggle;
